// extracted by mini-css-extract-plugin
module.exports = {"wtxlmx6":"wtxlmx6","t1xy4gs2":"t1xy4gs2","d1c3g5h0":"d1c3g5h0","s1aze96j":"s1aze96j"};